import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { LoadingService } from './loading.service';
import {takeUntil} from 'rxjs/operators';


@Component({
	selector: 'pgs-loading',
	templateUrl: './loading.component.html',
	styleUrls: ['./loading.component.scss'],
	animations: [
		trigger(
			'fade', [
			  transition(':enter', [
				style({ opacity: 0 }),
				animate('.3s', style({ opacity: .6}))
			  ]),
			  transition(':leave', [
				style({ opacity: .6 }),
				animate('.3s', style({ opacity: 0 }))
			  ])
			]
		  )
	]
})
export class LoadingComponent implements OnInit, OnDestroy {
	private ngUnsubscribe: Subject<void>;

	show = false;
	msg: string;

	constructor(private loadingService: LoadingService) { }

	ngOnInit() {
		this.ngUnsubscribe = new Subject<void>();
		this.loadingService.isVisible
    .pipe(takeUntil(this.ngUnsubscribe))
		.subscribe(value => {
      setTimeout(() => {
          this.show = value.show;
          this.msg = value.msg;
      });
    });
	}

	ngOnDestroy(): void {
		if (this.ngUnsubscribe) {
			this.ngUnsubscribe.next();
			this.ngUnsubscribe.complete();
		}
	}
}
